export const LIST_WORK_FITNESS_REQUEST = 'LIST_WORK_FITNESS_REQUEST'
export const LIST_WORK_FITNESS_SUCCESS = 'LIST_WORK_FITNESS_SUCCESS'
export const LIST_WORK_FITNESS_FAIL = 'LIST_WORK_FITNESS_FAIL'

export const LIST_WORK_FITNESS_SUMMARY_REQUEST = 'LIST_WORK_FITNESS_SUMMARY_REQUEST'
export const LIST_WORK_FITNESS_SUMMARY_SUCCESS = 'LIST_WORK_FITNESS_SUMMARY_SUCCESS'
export const LIST_WORK_FITNESS_SUMMARY_FAIL = 'LIST_WORK_FITNESS_SUMMARY_FAIL'

export const CREATE_WORK_FITNESS_REQUEST = 'CREATE_WORK_FITNESS_REQUEST'
export const CREATE_WORK_FITNESS_SUCCESS = 'CREATE_WORK_FITNESS_SUCCESS'
export const CREATE_WORK_FITNESS_FAIL = 'CREATE_WORK_FITNESS_FAIL'

export const DETAIL_WORK_FITNESS_REQUEST = 'DETAIL_WORK_FITNESS_REQUEST'
export const DETAIL_WORK_FITNESS_SUCCESS = 'DETAIL_WORK_FITNESS_SUCCESS'
export const DETAIL_WORK_FITNESS_FAIL = 'DETAIL_WORK_FITNESS_FAIL'

export const UPDATE_WORK_FITNESS_REQUEST = 'UPDATE_WORK_FITNESS_REQUEST'
export const UPDATE_WORK_FITNESS_SUCCESS = 'UPDATE_WORK_FITNESS_SUCCESS'
export const UPDATE_WORK_FITNESS_FAIL = 'UPDATE_WORK_FITNESS_FAIL'

export const DELETE_WORK_FITNESS_REQUEST = 'DELETE_WORK_FITNESS_REQUEST'
export const DELETE_WORK_FITNESS_SUCCESS = 'DELETE_WORK_FITNESS_SUCCESS'
export const DELETE_WORK_FITNESS_FAIL = 'DELETE_WORK_FITNESS_FAIL'

export const RESET_WORK_FITNESS = 'RESET_WORK_FITNESS'
